import {
  AnnotationState,
  TaskType,
  TaskGroupType,
} from 'packages/lib/api/annotations/contract/enums';

export const roles = ['qa', 'label', 'audit', 'flagged', 'error'] as const;
export type Role = (typeof roles)[number];

type Persona = 'view' | 'qa' | 'label';

export type AnnotationTool =
  | 'classification-enrichment'
  | 'scene-enrichment'
  | 'lidar-box'
  | 'lidar-top-down'
  | 'lidar-seg'
  | 'instance-seg'
  | 'sem-seg'
  | 'eva'
  | 'audio-labeling'
  | 'traffic-light-detection'
  | 'lidar-box-enrichment';

export const workflows: AnnotationTool[] = [
  'classification-enrichment',
  'scene-enrichment',
  'instance-seg',
  'lidar-seg',
  'sem-seg',
  'eva',
  'lidar-box',
  'lidar-top-down',
  'audio-labeling',
  'traffic-light-detection',
  'lidar-box-enrichment',
];

export const taskTypeToWorkflowAlias: Record<string, AnnotationTool> = {
  ImageEnrichment: 'classification-enrichment',
  SceneEnrichment: 'scene-enrichment',
  InstanceSeg: 'instance-seg',
  ImageBox: 'instance-seg',
  PolygonGrouping: 'instance-seg',
  LidarSeg: 'lidar-seg',
  TrafficLight: 'traffic-light-detection',
  SemSeg: 'sem-seg',
  VideoEvent: 'eva',
  LidarBox: 'lidar-box',
  LidarTopDown: 'lidar-top-down',
  Audio: 'audio-labeling',
  LidarBoxEnrichment: 'lidar-box-enrichment',
};

export const roleToDefaultPersonaMap: Record<Role, Persona> = {
  qa: 'qa',
  label: 'label',
  audit: 'qa',
  flagged: 'qa',
  error: 'qa',
};

export const roleToInitialStateMap: Record<Role, AnnotationState> = {
  qa: 'QaToDo',
  label: 'ToDo',
  audit: 'AuditToDo',
  flagged: 'Flagged',
  error: 'Error',
};

export const roleToNextStateMap: Record<Role, AnnotationState> = {
  qa: 'QaInProgress',
  label: 'AnnotationInProgress',
  audit: 'AuditInProgress',
  flagged: 'FlaggedInReview',
  error: 'ErrorInReview',
};

export const pipelines: Record<AnnotationTool, TaskType[]> = {
  'classification-enrichment': ['ImageEnrichment'],
  'scene-enrichment': ['SceneEnrichment'],
  'lidar-box': [
    'Fusion',
    'GtRegression',
    'DefectTracking',
    'GenericObject',
    'FullScene',
    'RareObjects',
  ],
  'lidar-top-down': ['LidarTopDown'],
  'lidar-seg': ['Fusion'],
  'instance-seg': ['Fusion', 'Image', 'PartialImage'],
  'sem-seg': ['Fusion', 'Image'],
  eva: ['VideoEvent'],
  'audio-labeling': ['Audio'],
  'traffic-light-detection': ['TrafficLight'],
  'lidar-box-enrichment': ['LidarBoxEnrichment'],
};

export const workflowToTaskGroupTypes: Record<AnnotationTool, TaskGroupType[]> =
  {
    'classification-enrichment': ['ImageEnrichment'],
    'scene-enrichment': ['SceneEnrichment'],
    'instance-seg': [
      'ImageBox',
      'InstanceSeg',
      'PolygonGrouping',
      'ImageEnrichment',
    ],
    'lidar-seg': ['LidarSeg'],
    'sem-seg': ['SemSeg'],
    eva: ['VideoEvent'],
    'lidar-box': ['LidarBox'],
    'lidar-top-down': ['LidarTopDown'],
    'audio-labeling': ['Audio'],
    'traffic-light-detection': ['TrafficLight'],
    'lidar-box-enrichment': ['LidarBoxEnrichment'],
  };
